export default class Storage {
  constructor () {
    // If there's no settings then create one
    if (!global.settings) {
      global.settings = {}
    }
  }

  has (key) {
    return (global.settings[key] !== undefined)
  }

  get (key) {
    if (this.has(key)) {
      return global.settings[key]
    }
    return null
  }

  set (key, value) {
    global.settings[key] = value
  }

  clear (key) {
    global.settings[key] = null
    delete global.settings[key]
  }

  getJSON (key) {
    if (this.has(key)) {
      return this.parseJSON(global.settings[key])
    }
    return null
  }

  putJSON (key, value) {
    this.set(key, JSON.stringify(value))
  }

  parseJSON (value) {
    // Check if value is not undefined
    if (typeof value === 'undefined') { return null }

    // Check if value is JSON Object
    if (typeof value === 'object') { return value }

    try {
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  }
}